import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import L from 'leaflet';
import 'leaflet.pattern';
import shortid from 'shortid';
//import * as ss from 'simple-statistics';
//import * as d3 from 'd3';
import numeral from 'numeral';
import chroma from 'chroma-js';
import FontAwesome from 'react-fontawesome';
import { Map, Pane, TileLayer, LayersControl, ScaleControl, GeoJSON, Tooltip, Popup, withLeaflet } from 'react-leaflet';
import Control from 'react-leaflet-control';
import LegendScale from './LegendScale';
import ReactLoading from 'react-loading';
import { fetchOverlays, fetchData } from '../../actions'
import { chooseProperty, propertySearch, viewpointChange, recenterMap, loseProperty } from '../../actions/map';
//import { dataFiltered } from '../../actions/data';
//import { filterData } from '../../actions/filter';
//import { style_properties, style_llcs } from './overlay_styles.js';
//import { ContoursOptions, MauiParcelsOptions } from './overlay_styles.js';
import { style_properties_cpr, style_properties_cpr_no_sub, style_fields_crops, style_ditches, style_emi_ditches, style_emi_streams, style_solar, style_aes_aoi, style_farming, style_points, style_polygons, style_fields_mono, style_fields_outline, style_parcels_outline, style_fuel_wells, style_cemeteries, style_fuel_tanks, style_pumps, style_mills, style_endangered_species, style_transformers, style_state_land, style_water, style_cade, style_camps, style_dumps, style_old_roads, style_pineapple_pesticides, style_pineapple_fields, style_cesspools, style_parcels_east, style_parcels_purchase, style_parcels_a, style_fields_2022, style_fields_2021, style_fields_west_2021, style_military_areas,
style_farmable_acres, style_wahaiwa_parcels, style_dole_parcels, style_comps_parcels, style_comm_ind_use, style_issues_polygons } from './overlay_styles.js';
//import { onEveryFeatureProperties } from './overlay_styles.js';
import { onEveryFeatureFieldsCrops, onEveryFeatureTreatment, onEveryFeatureMeters, onEveryFeatureIssue, onEveryFeatureFarming, onEveryFeatureIssueLabels, onEveryFeatureParcelsLabels, onEveryFeatureRes, onEveryFeatureFuelTanks, onEveryFeatureCesspools, onEveryFeatureFuelWells, onEveryFeatureFields, onEveryFeatureEast, onEveryFeatureEastLabels, onEveryFeatureMilitary, onEveryFeatureWahaiwa, onEveryFeatureDole, onEveryFeatureComps } from './overlay_styles.js';
import 'font-awesome/css/font-awesome.css';
import 'leaflet/dist/leaflet.css';
import map_styles from '../../css/map.css';
import VectorGridDefault from 'react-leaflet-vectorgrid'

const { BaseLayer, Overlay } = LayersControl

/* wrap the VectorGrid component using `withLeaflet` HOC */
const VectorGrid = withLeaflet(VectorGridDefault)

/*const format = (number) => {
  var form = "";
  number = parseFloat(number)
  switch (true){
    case (number >= 10000 || number%1 === 0):
      form = ".2s";
    break
    case (number < 10000 && number >= 100):
      form = ".5r";
    break
    case (number < 100 && number >= .001):
      form = ".3r";
    break
    case (number < .001):
      form = ".0e"
    break
    default:
  }
  return d3.format(form)(number);
}*/

function getIssueColor(owner) {
  switch (owner) {
    case "A & B":
      return '#003060'

    case "Mahi Pono":
      return '#b51d6d';

    case "Both":
      return '#FFE800';

    default:
      return null;
  }
}

const LegendRow = (props) => {
  var text = props.category;
  let color = props.color;

  if(!text) {
    text = 'Null';
  }

  return (
    <div className='legendRow' >
      <div style={{minWidth:50 + 'px', float:'left'}}>
        <div className='legendCircle' style={{
          "background": color,
          "borderRadius":0,
          "width": 50 + 'px',
          "height": 25 + 'px',
          "border":"3px solid " + color,
          "marginTop": "5px",
          "marginBottom": "5px",
          "marginRight": "5px",
          "marginLeft": 5 + 'px'
        }}>
        </div>
      </div>
      <div style={{paddingTop: 7.5 + 'px', minWidth: 50 + 'px', float:'left' }}>
        {text}
      </div>
      <div style={{clear:"both"}}></div>
    </div>
  )
}

const Legend = (props) => {
  let values = props.categories;
  let colors = props.colors;
  let title = props.scalar;

  var legendRows = [];

  if(Array.isArray(colors)) {
    for(let i = 0; i < values.size; i++) {
      legendRows.push((
          <LegendRow key={i} i={i} color={colors[i]} category={values.get(i)} />
      ));
    }
  } else {
    for(let i = 0; i < values.size; i++) {
      if(values.get(i)) {
        legendRows.push((
            <LegendRow key={i} i={i} color={colors[values.get(i)]} category={values.get(i)} />
        ));
      }
    }
  }

  return (
    <div style={{margin:'10px', padding:'10px', background:'rgba(255,255,255,.9)', borderRadius:"5px", 'boxShadow': '0px 1px 5px rgba(0,0,0,0.35)'}}>
      <h4>{title}</h4>
      {legendRows}
    </div>
  );

};

const LegendContinuous = (props) => {
  let title = props.scalar;
  let min = props.min;
  let max = props.max;
  let fill = props.colorScale;

  return (
    <div style={{margin:'10px', padding:'10px', background:'rgba(255,255,255,.9)', borderRadius:"5px", 'boxShadow': '0px 1px 5px rgba(0,0,0,0.35)'}}>
      <h4>{title}</h4>
      <LegendScale height={250} width={150} fill={fill} min={min} max={max} />
    </div>
  );

};

class DataMapViewComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltips: true,
      draggable:true,
      stripes: new L.StripePattern({ weight: 4, spaceWeight: 4, color: '#85def2', spaceColor: '#ffffff', opacity: 0.8, spaceOpacity: 0.4}),
      comm_stripes: new L.StripePattern({ weight: 4, spaceWeight: 4, color: '#f785e8', spaceColor: '#ffffff', opacity: 0.8, spaceOpacity: 0.4}),
      easement_stripes: new L.StripePattern({ weight: 4, spaceWeight: 4, color: '#85f785', spaceColor: '#ffffff', opacity: 0.8, spaceOpacity: 0.4}),
      high_impact_stripes: new L.StripePattern({ weight: 4, spaceWeight: 4, color: '#028a0f', spaceColor: '#ffffff', opacity: 0.8, spaceOpacity: 0.4}),
      low_impact_stripes: new L.StripePattern({ weight: 4, spaceWeight: 4, color: '#aef359', spaceColor: '#ffffff', opacity: 0.8, spaceOpacity: 0.4, angle: 90})
    }
  }

  componentWillMount(){
    if(this.props.properties.size === 0) {
      this.props.dispatch(fetchOverlays());
    }
    if(this.props.data.size === 0) {
      this.props.dispatch(fetchData());
    }
  }

  componentDidMount(){
    this.state.stripes.addTo(this.refs.map.leafletElement);
    this.state.comm_stripes.addTo(this.refs.map.leafletElement);
    this.state.easement_stripes.addTo(this.refs.map.leafletElement);
    this.state.high_impact_stripes.addTo(this.refs.map.leafletElement);
    this.state.low_impact_stripes.addTo(this.refs.map.leafletElement);
  }

  componentDidUpdate(){
    const { popupLocation } = this.refs //, edit
    if(this.props.foundProperty && popupLocation) {
      popupLocation.leafletElement.openPopup()
      setTimeout(function(){
        this.props.dispatch(loseProperty());
      }.bind(this), 5000);  // wait 5 seconds, then clear out the chosen location.
    }
  }

  handleAllPropertyClick(e){
    this.props.dispatch(chooseProperty(e.layer.feature.properties.cty_tmk));
  }
  handlePropertyClick(property){
    this.props.dispatch(chooseProperty(property));
  }
  handlePropertyHover(e){
    e.target.bringToFront();
  }

  performPropertySearch(e){
    if(e.keyCode === 13) {
      this.props.dispatch(propertySearch(e.target.value));
    }
  }

  clearPropertySearchProps() {
    this.props.dispatch(loseProperty());
  }

  recenterMap() {
    this.props.dispatch(recenterMap());
  }

  toggleTooltips() {
    this.setState({ tooltips: !this.state.tooltips })
  }

  viewpointChanged(viewpoint){
    this.props.dispatch(viewpointChange(viewpoint));
  }

  onEveryFeatureFieldsLabels(feature, layer){
    if (feature.properties.Name) {
      layer.bindPopup('<b>Field:</b> ' + feature.properties.Name + '</br><b>Acres:</b> ' + feature.properties.gisacrs).bindTooltip(feature.properties.Name, { permanent: true, direction: 'center', className: "ToolTipFields", offset: [0, 0] })
    } else {
      layer.bindPopup('<b>Field:</b> No Field Name</br><b>Acres:</b> ' + feature.properties.gisacrs)
    }
  }

  render() {
    const { isBusy } = this.props;
    const { high_impact_stripes, low_impact_stripes } = this.state;
    var propertySearch =(<input className="form-control" type="search" placeholder="find a property by TMK" onKeyDown={this.performPropertySearch.bind(this)} tabIndex="0" style={{'width':'200px', 'height':'45px', 'marginRight':'350px', 'padding':'10px', 'background':'rgba(255,255,255,.9)', 'borderRadius':"5px", 'boxShadow': '0px 1px 5px rgba(0,0,0,0.35)'}}/>)
    var fitBounds =(
      <button className="recenterButton" onClick={() => this.recenterMap()} type="button" style={{'cursor': 'pointer', 'width':'34px', 'height':'33px'}}>
        <span style={{ textAlign: 'center' }}><FontAwesome name='crosshairs' style={{textAlign: 'center', textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)', 'fontSize': '20px', verticalAlign: 'middle', 'lineHeight': '20px' }} /></span>
      </button>
    )

    /*var properties = undefined;
    if(this.props.properties.size > 0) {
      properties = (<GeoJSON key={1} data={this.props.properties.toJSON()} style={style_outline_properties} ></GeoJSON>);
    }*/

    function sortJSON(data, key, property, way) {
      // eslint-disable-next-line array-callback-return
      return data.sort(function(a, b) {
          var x = a[key][property]; var y = b[key][property];
          if (way === '123' ) { return ((x < y) ? -1 : ((x > y) ? 1 : 0)); }
          if (way === '321') { return ((x > y) ? -1 : ((x < y) ? 1 : 0)); }
      });
    }

    var parcels = undefined,
        ditches = undefined,
        fields = undefined,
        fieldsLabeled = undefined,
        fields_outlined = undefined,
        fieldsLabeled_outlined = undefined,
        //wells = undefined,
        //wells_dom = undefined,
        //wells_mun = undefined,
        reservoirs = undefined,
        fuel_wells = undefined,
        fuel_tanks = undefined,
        pumps = undefined,
        camps = undefined,
        dumping = undefined,
        other = undefined,
        cade = undefined,
        carve = undefined,
        old_roads = undefined,
        mills = undefined,
        //landfills = undefined,
        cemeteries = undefined,
        state_land = undefined,
        endangered_species = undefined,
        transformers = undefined,
        pineapple_fields = undefined,
        pineapple_pesticides = undefined,
        cesspools = undefined,
        //comm_carve = undefined,
        //include_properties = undefined,
        //legal_entities = undefined,
        meters = undefined,
        easements = undefined,
        all_env_issues = undefined,
        all_env_issues_labeled = undefined,
        all_env_issues_owner = undefined,
        solar_projects = undefined,
        farming_limitations = undefined,
        east_maui_ditches = undefined,
        emi_streams = undefined,
        fields_crops = undefined,
        all_parcels = undefined,
        topography = undefined,
        ab_owned_east = undefined,
        ab_owned_east_labels = undefined,
        ab_purchase_targets_2021 = undefined,
        ab_purchase_targets_2021_labels = undefined,
        schedule_a_parcels = undefined,
        fields_proposed_2022 = undefined,
        fields_planted_2021 = undefined,
        fields_west_2021 = undefined,
        military_areas = undefined,
        military_impacts = undefined,
        oahu_farmable_acres = undefined,
        oahu_wahiawa_parcels = undefined,
        oahu_dole_parcels = undefined,
        oahu_comps_parcels = undefined,
        aes_aoi = undefined,
        comm_ind_use = undefined,
        parcels_cpr = undefined,
        parcels_cpr_no_sub = undefined,
        water_treatment = undefined;

    let MauiParcelsOptions = null;
    let ContoursOptions = null;

    if(this.props.overlays.size > 0) {
      let MauiParcelsOptions = {
        type: 'protobuf',
        url: '/api/overlay/parcels/{z}/{x}/{y}.pbf',
        subdomains: 'abc',
        zIndex: 299,
        popup: (feature) => `<div><b>TMK:</b> ${feature.properties.tmk_txt}</div>`,
        fetchOptions: { credentials: 'include', headers: { Authorization: 'Bearer ' + sessionStorage.getItem('jwt'), 'Content-Type': 'application/json' } },
        vectorTileLayerStyles: {
          geojsonLayer: {
            fill: true,
            color: '#D9831F',
            fillColor: '#D9831F',
            fillOpacity: 0.0,
            weight: 0.8,
            zIndex: 299
          }
        }
      }

      let ContoursOptions = {
        type: 'protobuf',
        url: '/api/mbtiles/{z}/{x}/{y}.pbf',
        subdomains: 'abc',
        zIndex: 299,
        tooltip: (feature) => `<div>${feature.properties.ELEV_ft} ft</div>`,
        popup: (feature) => `<div>${feature.properties.ELEV_ft} ft</div>`,
        fetchOptions: { credentials: 'include', headers: { Authorization: 'Bearer ' + sessionStorage.getItem('jwt'), 'Content-Type': 'application/json' } },
        vectorTileLayerStyles: {
          contours_20ft: {
            weight: 1.2,
            color: '#25221E',
            dashArray: '5, 2',
            fillOpacity: 0
          },
          contours_50ft: {
            weight: 1.2,
            color: '#25221E',
            dashArray: '5, 2',
            fillOpacity: 0
          },
          contours_100ft: {
            weight: 1.2,
            color: '#25221E',
            dashArray: '5, 2',
            fillOpacity: 0
          },
          contours_200ft: {
            weight: 1.2,
            color: '#25221E',
            dashArray: '5, 2',
            fillOpacity: 0
          }
        }
      }
      all_parcels = (<VectorGrid key={101} {...MauiParcelsOptions}></VectorGrid>);
      topography = (<VectorGrid key={102} {...ContoursOptions}></VectorGrid>);
      var overlays = this.props.overlays.toJS()
      ditches = (<GeoJSON key={3} data={overlays[0]} style={style_ditches}></GeoJSON>);
      fields = (<GeoJSON key={4} data={overlays[1]} onEachFeature={onEveryFeatureFields} style={style_fields_mono}></GeoJSON>);
      fieldsLabeled = (<GeoJSON key={8} data={overlays[1]} onEachFeature={this.onEveryFeatureFieldsLabels} style={style_fields_mono}></GeoJSON>);
      fields_outlined = (<GeoJSON key={4} data={overlays[1]} onEachFeature={onEveryFeatureFields} style={style_fields_outline}></GeoJSON>);
      fieldsLabeled_outlined = (<GeoJSON key={8} data={overlays[1]} onEachFeature={this.onEveryFeatureFieldsLabels} style={style_fields_outline}></GeoJSON>);
      //wells = (<GeoJSON key={5} data={overlays[2]} onEachFeature={onEveryFeatureWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_wells);}}></GeoJSON>);
      //wells_dom = (<GeoJSON key={6} data={overlays[3]} onEachFeature={onEveryFeatureWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_wells_dom);}}></GeoJSON>);
      //wells_mun = (<GeoJSON key={7} data={overlays[4]} onEachFeature={onEveryFeatureWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_wells_mun);}}></GeoJSON>);
      reservoirs = (<GeoJSON key={9} data={overlays[5]} onEachFeature={onEveryFeatureRes} style={style_water}></GeoJSON>);
      fuel_wells = (<GeoJSON key={10} data={overlays[6]} onEachFeature={onEveryFeatureFuelWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_fuel_wells);}}></GeoJSON>);
      fuel_tanks = (<GeoJSON key={11} data={overlays[7]} onEachFeature={onEveryFeatureFuelTanks} style={style_fuel_tanks}></GeoJSON>);
      pumps = (<GeoJSON key={12} data={overlays[8]} onEachFeature={onEveryFeatureFuelWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_pumps);}}></GeoJSON>);
      camps = (<GeoJSON key={13} data={overlays[9]} onEachFeature={onEveryFeatureRes} style={style_camps}></GeoJSON>);
      dumping = (<GeoJSON key={14} data={overlays[10]} onEachFeature={onEveryFeatureRes} style={style_dumps}></GeoJSON>);
      other = (<GeoJSON key={15} data={overlays[11]} onEachFeature={onEveryFeatureRes} style={style_fields_mono}></GeoJSON>);
      cade = (<GeoJSON key={16} data={overlays[12]} onEachFeature={onEveryFeatureRes} style={style_cade}></GeoJSON>);
      carve = (<GeoJSON key={17} data={overlays[13]} onEachFeature={onEveryFeatureRes} style={ {
        fillPattern: this.state.stripes,
        color: "#6c797c",
        fillOpacity: 0.8,
        opacity: 0.8,
        weight: 1.2,
        zIndex: 15
      } }></GeoJSON>);
      old_roads = (<GeoJSON key={18} data={overlays[14]} style={style_old_roads}></GeoJSON>);
      mills = (<GeoJSON key={19} data={overlays[15]} onEachFeature={onEveryFeatureRes} style={style_mills}></GeoJSON>);
      //landfills = (<GeoJSON key={20} data={overlays[16]} onEachFeature={onEveryFeatureRes} style={style_landfills}></GeoJSON>);
      cemeteries = (<GeoJSON key={21} data={overlays[16]} onEachFeature={onEveryFeatureFuelWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_cemeteries);}}></GeoJSON>);
      state_land = (<GeoJSON key={22} data={overlays[17]} onEachFeature={onEveryFeatureRes} style={style_state_land}></GeoJSON>);
      endangered_species = (<GeoJSON key={23} data={overlays[18]} onEachFeature={onEveryFeatureRes} style={style_endangered_species}></GeoJSON>);
      transformers = (<GeoJSON key={24} data={overlays[19]} onEachFeature={onEveryFeatureRes} style={style_transformers}></GeoJSON>);

      //include_properties = (<GeoJSON key={25} data={overlays[20]} style={style_properties} ></GeoJSON>);

      cesspools = (<GeoJSON key={26} data={overlays[21]} onEachFeature={onEveryFeatureCesspools} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_cesspools);}} ></GeoJSON>);
      pineapple_fields = (<GeoJSON key={27} data={overlays[22]} onEachFeature={onEveryFeatureRes} style={style_pineapple_fields} ></GeoJSON>);
      pineapple_pesticides = (<GeoJSON key={28} data={overlays[23]} onEachFeature={onEveryFeatureRes} style={style_pineapple_pesticides} ></GeoJSON>);
      /*comm_carve = (<GeoJSON key={29} data={overlays[24]} onEachFeature={onEveryFeatureRes} style={ {
        fillPattern: this.state.comm_stripes,
        color: "#6c797c",
        fillOpacity: 0.8,
        opacity: 0.8,
        weight: 1.2,
        zIndex: 15
      } }></GeoJSON>);*/
      //legal_entities = (<GeoJSON key={30} data={overlays[25]} onEachFeature={onEveryFeatureLLC} style={style_llcs} ></GeoJSON>);
      meters = (<GeoJSON key={31} data={overlays[26]} onEachFeature={onEveryFeatureMeters} pointToLayer={function(feature, latlng) {
        if(feature.properties.label === "HC&S Sub Meters - Surface Water") {
          return L.circleMarker(latlng, {radius: 4.5, color: '#ff9f1a', fillColor: '#ff9f1a', fillOpacity: 0.0, weight: 1.2, zIndex: 455});
        } else if(feature.properties.label === "HC&S Sub Meters - County Water") {
          return L.circleMarker(latlng, {radius: 4.5, color: '#7efff5', fillColor: '#7efff5', fillOpacity: 0.0, weight: 1.2, zIndex: 455});
        } else {
          return L.circleMarker(latlng, {radius: 4.5, color: '#fff200', fillColor: '#fff200', fillOpacity: 0.0, weight: 1.2, zIndex: 455});
        }
      }} ></GeoJSON>);
      easements = (<GeoJSON key={32} data={overlays[27]} onEachFeature={onEveryFeatureRes} style={ {
        fillPattern: this.state.easement_stripes,
        color: "#6c797c",
        fillOpacity: 0.8,
        opacity: 0.8,
        weight: 1.2,
        zIndex: 15
      } }></GeoJSON>);
      parcels = (<GeoJSON key={33} data={overlays[28]} onEachFeature={onEveryFeatureParcelsLabels} style={style_parcels_outline}></GeoJSON>);
      all_env_issues = (<GeoJSON key={34} data={overlays[29]} onEachFeature={onEveryFeatureIssue} style={style_polygons} pointToLayer={function(feature, latlng){
        if(feature.geometry.type === 'MultiPoint' || feature.geometry.type === 'Point') {
          return L.circleMarker(latlng, style_points)
        } else {
          return L.polygon(latlng, style_polygons)
        }
      }}></GeoJSON>);
      all_env_issues_labeled = (<GeoJSON key={35} data={overlays[29]} onEachFeature={onEveryFeatureIssueLabels} style={style_polygons} pointToLayer={function(feature, latlng){
        if(feature.geometry.type === 'MultiPoint' || feature.geometry.type === 'Point') {
          return L.circleMarker(latlng, style_points)
        } else {
          return L.polygon(latlng, style_polygons)
        }
      }}></GeoJSON>);
      all_env_issues_owner = (<GeoJSON key={34} data={overlays[29]} onEachFeature={onEveryFeatureIssue} style={style_issues_polygons} pointToLayer={function(feature, latlng){
        if(feature.geometry.type === 'MultiPoint' || feature.geometry.type === 'Point') {
          return L.circleMarker(latlng, {
              radius: 4,
              fillColor: getIssueColor(feature.properties.Owner),
              color: getIssueColor(feature.properties.Owner),
              fillOpacity: 0.8,
              weight: 0.6,
              zIndex: 15
          })
        } else {
          return L.polygon(latlng, {
            fillColor: getIssueColor(feature.properties.Owner),
            color: getIssueColor(feature.properties.Owner),
            fillOpacity: 0.3,
            opacity: 0.8,
            weight: 1.2,
            zIndex: 15
          })
        }
      }}></GeoJSON>);
      solar_projects = (<GeoJSON key={36} data={overlays[30]} onEachFeature={onEveryFeatureRes} style={style_solar}></GeoJSON>);
      var updated_farming_features = sortJSON(overlays[31].features, 'properties', 'Farmable', '321');
      overlays[31].features = updated_farming_features;
      farming_limitations = (<GeoJSON key={37} data={overlays[31]} onEachFeature={onEveryFeatureFarming} style={style_farming}></GeoJSON>);
      east_maui_ditches = (<GeoJSON key={38} data={overlays[32]} style={style_emi_ditches}></GeoJSON>);
      emi_streams = (<GeoJSON key={39} data={overlays[33]} style={style_emi_streams}></GeoJSON>);
      // fields_crops = (<GeoJSON key={40} data={overlays[34]} onEachFeature={onEveryFeatureFieldsCrops} style={style_fields_crops}></GeoJSON>)
      //fields_crops = (<GeoJSON key={40} data={overlays[47]} onEachFeature={onEveryFeatureFieldsCrops} style={style_fields_crops}></GeoJSON>)
      fields_crops = (<GeoJSON key={40} data={overlays[49]} onEachFeature={onEveryFeatureFieldsCrops} style={style_fields_crops}></GeoJSON>)
      ab_owned_east = (<GeoJSON key={41} data={overlays[35]} onEachFeature={onEveryFeatureEast} style={style_parcels_east}></GeoJSON>)
      ab_owned_east_labels = (<GeoJSON key={42} data={overlays[35]} onEachFeature={onEveryFeatureEastLabels} style={style_parcels_east}></GeoJSON>)
      ab_purchase_targets_2021 = (<GeoJSON key={43} data={overlays[36]} onEachFeature={onEveryFeatureEast} style={style_parcels_purchase}></GeoJSON>)
      ab_purchase_targets_2021_labels = (<GeoJSON key={44} data={overlays[36]} onEachFeature={onEveryFeatureEastLabels} style={style_parcels_purchase}></GeoJSON>)
      schedule_a_parcels = (<GeoJSON key={45} data={overlays[37]} onEachFeature={onEveryFeatureEast} style={style_parcels_a}></GeoJSON>)
      fields_proposed_2022 = (<GeoJSON key={46} data={overlays[38]} style={style_fields_2022}></GeoJSON>)
      fields_planted_2021 = (<GeoJSON key={47} data={overlays[39]} style={style_fields_2021}></GeoJSON>)
      fields_west_2021 = (<GeoJSON key={48} data={overlays[40]} style={style_fields_west_2021}></GeoJSON>)
      military_areas = (<GeoJSON key={49} data={overlays[41]} style={style_military_areas} onEachFeature={onEveryFeatureMilitary}></GeoJSON>)
      military_impacts = (<GeoJSON key={50} data={overlays[42]} style={ function(feature) {
        return {
          fillPattern: feature.properties.Level === 'Heavy' ? high_impact_stripes : low_impact_stripes,
          color: feature.properties.Level === 'Heavy' ? '#028a0f' : '#aef359',
          fillOpacity: 0.8,
          opacity: 0.8,
          weight: 1.2,
          zIndex: 15
        };
      } } onEachFeature={onEveryFeatureMilitary}></GeoJSON>);
      oahu_farmable_acres = (<GeoJSON key={51} data={overlays[43]} style={style_farmable_acres}></GeoJSON>)
      oahu_wahiawa_parcels = (<GeoJSON key={52} data={overlays[44]} style={style_wahaiwa_parcels} onEachFeature={onEveryFeatureWahaiwa}></GeoJSON>)
      oahu_dole_parcels = (<GeoJSON key={53} data={overlays[45]} style={style_dole_parcels} onEachFeature={onEveryFeatureDole}></GeoJSON>)
      oahu_comps_parcels = (<GeoJSON key={54} data={overlays[46]} style={style_comps_parcels} onEachFeature={onEveryFeatureComps}></GeoJSON>)
      aes_aoi = (<GeoJSON key={55} data={overlays[48]} style={style_aes_aoi}></GeoJSON>)
      comm_ind_use = (<GeoJSON key={56} data={overlays[50]} style={style_comm_ind_use}></GeoJSON>)
      parcels_cpr = (<GeoJSON key={57} data={overlays[51]} style={style_properties_cpr}></GeoJSON>);
      parcels_cpr_no_sub = (<GeoJSON key={58} data={overlays[52]} style={style_properties_cpr_no_sub}></GeoJSON>);
      water_treatment = (<GeoJSON key={59} data={overlays[53]} onEachFeature={onEveryFeatureTreatment} pointToLayer={function(feature, latlng) { return L.circleMarker(latlng, {radius: 5, color: '#1D0200', fillColor: '#7393B3', fillOpacity: 1.0, weight: 1.2, zIndex: 455}); }}></GeoJSON>);
    }

    var data = this.props.filteredProperties,//.filter(x => x.get('visible')),
        filteredProperties = null,
        fillOp = 0,
        colors,
        colorFx,
        foundFx,
        selectedFx,
        highlightFx,
        noShowFx,
        mouseoverFx,
        weight,
        scalar = this.props.parameter.value,
        scalarLabel = this.props.parameter.label,
        scalarType = this.props.parameterType,
        maxStat,
        minStat,
        values,
        legend = null,
        key;

    let colorScales = {
      value: 'Oranges',
      acres_owned: chroma.scale('YlGn').gamma(2),
      acres: chroma.scale('YlGn').gamma(2),
      owner: 'Set1',
      legal_entity: {"MP West, LLC": '#c0392b', "MP CPR, LLC": '#95a5a6', "MP EMI, LLC": '#3498db', "MP Central A, LLC": '#f39c12', "MP Central B, LLC": '#8e44ad', "MP East A, LLC": '#273c75', "MP East B, LLC": '#2ecc71'},
      include: {"Include": '#ffffff', "Include (has Carve Out)": '#fffff0', "Restricted": '#f2f2f2', "CPR Carve Out": '#999990'},
      is_core: ['yellow', 'red', 'black'],
      portion_reserved_at_closing: 'PRGn',
      request_for_deregistration_submitted: 'Dark2',
      is_title_insurable: 'BrBG',
      is_ial: 'Paired',
      ab_risk_rank: 'RdYlBu',
      m_risk_rank: 'OrRd'
    }

    if(data.size){

      noShowFx = function(feature){
        return {
          color: 'charcoal',
          opacity: 0,
          fillColor: 'charcoal',
          fillOpacity: 0,
          weight: 0
        }
      }

      mouseoverFx = function(feature,layer) {
        weight = layer.options.weight;
        layer.on("mouseover",function(e){
            layer.setStyle({weight: (weight * 1.5)})
        });
        layer.on("mouseout",function(e){
            layer.setStyle({weight: weight})
        });
      }

      if(scalar && scalarType === 'Continuous' && this.props.fillProperties){

        maxStat = data.filter(row => row.get('visible')).map((row) => +row.get('data').get(scalar) || 0).max();
        minStat = data.filter(row => row.get('visible')).map((row) => +row.get('data').get(scalar) || 0).min();

        if(scalar === 'acres_owned' || scalar === 'acres') {
          colors = chroma.scale('YlGn').gamma(2).domain([minStat, maxStat])
        } else {
          colors = chroma.scale(['yellow', 'navy']).mode('lch').domain([minStat, maxStat])//.gamma(0.5);
        }

        colorFx = function(feature){
          return {
            color: colors(+feature.data[scalar]),
            opacity: 0.8,
            fillColor: colors(+feature.data[scalar]),
            fillOpacity: 0.8,
            weight: 0.6
          };
        }

        highlightFx = function(feature){
          return {
            color: map_styles.highlightColor,
            opacity: 1,
            fillColor: map_styles.highlightColor, //colors(+feature.data[scalar]),
            fillOpacity: 0.8,
            weight: 1
          };
        }

        selectedFx = function(feature){
          return {
            color: map_styles.selectedColor,
            opacity: 1,
            fillColor: map_styles.selectedColor, //colors(+feature.data[scalar]),
            fillOpacity: 0.8,
            weight: 1
          };
        }

        foundFx = function(feature){
          return {
            color: map_styles.foundColor,
            opacity: 1,
            fillColor: map_styles.foundColor, //colors(+feature.data[scalar]),
            fillOpacity: 0.8,
            weight: 1
          };
        }

        legend = (
          <LegendContinuous scalar={this.props.parameter.label} min={minStat} max={maxStat} colorScale={colors} />
        )
      } else if(scalar && scalarType === 'Discrete' && this.props.fillProperties) {

        if(scalar === 'm_risk_rank') {
          values = this.props.allData.filter((row) => row.get(scalar)).map((row) => row.get(scalar)).toSet().toList();
        } else if(scalar === 'include') {
          //values = this.props.allData.map((row) => row.get(scalar)).toSet().toList();
          values = fromJS(["Include", "Include (has Carve Out)", "Restricted", "CPR Carve Out"])
        } else {
          values = this.props.allData.map((row) => row.get(scalar)).toSet().toList();
        }

        if(scalar === 'legal_entity' || scalar === 'include') {
          colors = colorScales[scalar];
          colorFx = function(feature){
            return {
              //color: colors[feature.data[scalar]],
              color: '#3e3e3f',
              opacity: 1.0,
              //opacity: 0.8,
              fillColor: colors[feature.data[scalar]],
              fillOpacity: 0.5,
              weight: 0.6
            };
          }
        } else {
          colors = chroma.scale(colorScales[scalar]).padding(-0.15).colors(values.size);
          colorFx = function(feature){
            return {
              //color: colors[values.indexOf(feature.data[scalar])],
              color: '#3e3e3f',
              //opacity: 0.8,
              opacity: 1.0,
              fillColor: colors[values.indexOf(feature.data[scalar])],
              fillOpacity: 0.5,
              weight: 0.6
            };
          }
        }

        highlightFx = function(feature){
          return {
            color: map_styles.highlightColor,
            opacity: 1,
            fillColor: map_styles.highlightColor, //colors[values.indexOf(feature.data[scalar])],
            fillOpacity: 0.8,
            weight: 1
          };
        }

        selectedFx = function(feature){
          return {
            color: map_styles.selectedColor,
            opacity: 1,
            fillColor: map_styles.selectedColor, //colors[values.indexOf(feature.data[scalar])],
            fillOpacity: 0.8,
            weight: 1
          };
        }

        foundFx = function(feature){
          return {
            color: map_styles.foundColor,
            opacity: 1,
            fillColor: map_styles.foundColor, //colors[values.indexOf(feature.data[scalar])],
            fillOpacity: 0.8,
            weight: 1
          };
        }

        legend = (
          <Legend categories={values} scalar={this.props.parameter.label} colors={colors} />
        )
      } else {
        colors = null;

        colorFx = function(feature){
          if(feature.data) {
            //fillOp = feature.data.include === 'Exclude' ? 0.4 : 0
            fillOp = feature.data.include.includes('Exclude') ? 0.4 : 0
          } else {
            fillOp = 0
          }
          return {
            color: '#3e3e3f',
            opacity: 1,
            fillColor: '#3e3e3f', //'white',
            fillOpacity: fillOp,
            weight: 1.5
          };
        }

        highlightFx = function(feature){
          return {
            color: map_styles.highlightColor,
            opacity: 1,
            fillColor: map_styles.highlightColor,
            fillOpacity: 0.2,
            weight: 1
          };
        }

        selectedFx = function(feature){
          return {
            color: map_styles.selectedColor,
            opacity: 1,
            fillColor: map_styles.selectedColor,
            fillOpacity: 0.2,
            weight: 1
          };
        }

        foundFx = function(feature){
          return {
            color: map_styles.foundColor,
            opacity: 1,
            fillColor: map_styles.foundColor,
            fillOpacity: 0.2,
            weight: 3
          };
        }
        legend = null;
      }

      filteredProperties = data.map( (row, i) => {
          //key = i;
          //key = row.get('cty_tmk');
          key = shortid.generate();

          if(!row.get('visible')) {
            return (
              <GeoJSON
                key={key}
                data={row.toJS()}
                style={noShowFx}
              >
              </GeoJSON>
            )
          } else if(this.props.foundProperty && row.get('cty_tmk') === this.props.foundProperty && row.get('visible')) {
            return (
              <GeoJSON
                key={'1f'}
                ref="popupLocation"
                data={row.toJS()}
                style={foundFx}
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))}
                onMouseover={this.handlePropertyHover.bind(this)}
              >
                <Popup>
                  <span>{row.get('data').get('cty_tmk')}</span>
                </Popup>
              </GeoJSON>
            )
          } else if(this.props.selectedProperty && row.get('cty_tmk') === this.props.selectedProperty && row.get('visible')) {
            return (
              <GeoJSON
                key={key}
                data={row.toJS()}
                style={selectedFx}
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))}
                onMouseover={this.handlePropertyHover.bind(this)}
              >
              {this.state.tooltips ? (
                  scalar !== undefined ? (
                    scalarType === 'Continuous' ? (
                      <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                        <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + numeral(+row.get('data').get(scalar)).format('0,0')}</span>
                      </Tooltip> ) : (
                      <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                        <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + row.get('data').get(scalar)}</span>
                      </Tooltip>)
                    ) : (
                    <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                      <span>{row.get('data').get('cty_tmk')}</span>
                    </Tooltip> )
                  ) : ( null )
                }
              </GeoJSON>
            )
          } else if(this.props.histogramSelection[0] && this.props.parameterType === 'Discrete' && row.get('data').get(this.props.parameter.value) === (this.props.histogramSelection[0] === 'Null' ? null : this.props.histogramSelection[0]) && row.get('visible')) {
            return (
              <GeoJSON
                key={key}
                data={row.toJS()}
                style={highlightFx}
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))}
                onMouseover={this.handlePropertyHover.bind(this)}
              >
              {this.state.tooltips ? (
                <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                  <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + row.get('data').get(scalar)}</span>
                </Tooltip>
                ) : ( null )
              }
              </GeoJSON>
            )
          } else if(this.props.histogramSelection[0] && this.props.parameterType === 'Continuous' && +row.get('data').get(this.props.parameter.value) <= this.props.histogramSelection[1] && +row.get('data').get(this.props.parameter.value) > this.props.histogramSelection[0] && row.get('visible')) {
            return (
              <GeoJSON
                key={key}
                data={row.toJS()}
                style={highlightFx}
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))}
                onMouseover={this.handlePropertyHover.bind(this)}
              >
              {this.state.tooltips ? (
                <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                  <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + numeral(+row.get('data').get(scalar)).format('0,0')}</span>
                </Tooltip>
                ) : ( null )
              }
              </GeoJSON>
            )
          } else {
            return (
              <GeoJSON
                key={key}
                ref="popupLocation"
                data={row.toJS()}
                style={colorFx}
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))}
                onMouseover={this.handlePropertyHover.bind(this)}
                onEachFeature={mouseoverFx}
              >
                {this.state.tooltips ? (
                  scalar !== undefined ? (
                    scalarType === 'Continuous' ? (
                      <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                        <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + numeral(+row.get('data').get(scalar)).format('0,0')}</span>
                      </Tooltip> ) : (
                      <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                        <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + row.get('data').get(scalar)}</span>
                      </Tooltip>)
                    ) : (
                    <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                      <span>{row.get('data').get('cty_tmk')}</span>
                    </Tooltip> )
                  ) : ( null )
                }
              </GeoJSON>
            )
          }
        }
      )
    }

    return (
      <div className="map_container" style={{height: this.props.height}}>
        {isBusy ? (
          <div style={{marginTop: (this.props.height * 0.25), marginLeft: (this.props.width * 0.25), zIndex:1000000, width:'25%', height:'25%', backgroundColor:'rgba(255,255,255,0.0)', position:'absolute'}}>
            <ReactLoading type='bubbles' color='#333333' height='25%' width='50%' className='center-loader' />
          </div>) : (
          <div></div>
         )}
         <Map ref="map" center={this.props.mapCenter} zoom={this.props.mapZoom} onViewportChanged={this.viewpointChanged.bind(this)}>
          <LayersControl position='topleft'>
            <BaseLayer name='Open Street Map - Humanitarian'>
              <TileLayer
                url='https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.{ext}'
                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
                minZoom={0}
                maxZoom={19}
                ext='png'
              />
            </BaseLayer>
            <BaseLayer name='Open Street Map - Black And White'>
              <TileLayer
                url='https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.{ext}'
                attribution='Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                minZoom={0}
                maxZoom={18}
                ext='png'
              />
            </BaseLayer>
            <BaseLayer name='Stamen - Terrain'>
              <TileLayer
                url='https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.{ext}'
                attribution='Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>'
                subdomains='abcd'
                minZoom={0}
                maxZoom={18}
                ext='png'
              />
            </BaseLayer>
            <BaseLayer name='ESRI - World Topology'>
              <TileLayer
                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}'
                attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
              />
            </BaseLayer>
            <BaseLayer checked name='ESRI - World Imagery'>
              <TileLayer
                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
              />
            </BaseLayer>
            <BaseLayer name='ESRI - Grey Map'>
              <TileLayer
                url='https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}'
                attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
              />
            </BaseLayer>
            <BaseLayer name='CartoDB - Positron'>
              <TileLayer
                url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
                subdomains='abcd'
                maxZoom={19}
              />
            </BaseLayer>
            <BaseLayer name='CartoDB - Dark Matter'>
              <TileLayer
                url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png'
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://cartodb.com/attributions">CartoDB</a>'
                subdomains='abcd'
                maxZoom={19}
              />
            </BaseLayer>
            {ab_owned_east !== undefined ? (<Overlay name='A&B East Maui Parcels'>
              {ab_owned_east}
            </Overlay>) : null }
            {ab_owned_east_labels !== undefined ? (<Overlay name='A&B East Maui Parcels (Labeled)'>
              {ab_owned_east_labels}
            </Overlay>) : null }
            {parcels_cpr_no_sub !== undefined ? (<Overlay name='A&B No Subdivision'>
              {parcels_cpr_no_sub}
            </Overlay>) : null }
            {ab_purchase_targets_2021 !== undefined ? (<Overlay name='A&B Purchase Targets (2021)'>
              {ab_purchase_targets_2021}
            </Overlay>) : null }
            {ab_purchase_targets_2021_labels !== undefined ? (<Overlay name='A&B Purchase Targets (2021 - Labeled)'>
              {ab_purchase_targets_2021_labels}
            </Overlay>) : null }
            {aes_aoi !== undefined ? (<Overlay name='AES Area of Interest'>
              {aes_aoi}
            </Overlay>) : null }
            {all_env_issues !== undefined ? (<Overlay name='All Env. Issues'>
              {all_env_issues}
            </Overlay>) : null }
            {all_env_issues_owner !== undefined ? (<Overlay name='All Env. Issues (by Owner)'>
              {all_env_issues_owner}
            </Overlay>) : null }
            {all_env_issues_labeled !== undefined ? (<Overlay name='All Env. Issues (Labeled)'>
              {all_env_issues_labeled}
            </Overlay>) : null }
            {all_parcels !== undefined ? (<Overlay name='All Parcels'>
               {all_parcels}
            </Overlay> ) : null }
            {cade !== undefined ? (<Overlay name='CADE (Plant and Stations)'>
              {cade}
            </Overlay>) : null }
            {camps !== undefined ? (<Overlay name='Camps'>
              {camps}
            </Overlay>) : null }
            {cemeteries !== undefined ? (<Overlay name='Cemeteries'>
              {cemeteries}
            </Overlay>) : null }
            {cesspools !== undefined ? (<Overlay name='Cesspools (Many Locations Inaccurate)'>
              {cesspools}
            </Overlay>) : null }
            {comm_ind_use !== undefined ? (<Overlay name='Commercial/Industrial Use (Env. Issues)'>
              {comm_ind_use}
            </Overlay>) : null }
            {water_treatment !== undefined ? (<Overlay name='County Treatment Facilities'>
              {water_treatment}
            </Overlay>) : null }
            {carve !== undefined ? (<Overlay checked name='CPR Carve Outs'>
              {carve}
            </Overlay>) : null }
            {dumping !== undefined ? (<Overlay name='Dumps/Landfills'>
              {dumping}
            </Overlay>) : null }
            {easements !== undefined ? (<Overlay name='Environmental Easements'>
              {easements}
            </Overlay>) : null }
            {ditches !== undefined ? (<Overlay name='Farm Ditches'>
              {ditches}
            </Overlay>) : null }
            {east_maui_ditches !== undefined ? (<Overlay name='East Maui Ditches'>
              {east_maui_ditches}
            </Overlay>) : null }
            {emi_streams !== undefined ? (<Overlay name='EMI Streams'>
              {emi_streams}
            </Overlay>) : null }
            {farming_limitations !== undefined ? (<Overlay name='Farming Restrictions'>
              {farming_limitations}
            </Overlay>) : null }
            {fields !== undefined ? (<Overlay name='Fields'>
              {fields}
            </Overlay>) : null }
            {fieldsLabeled !== undefined ? (<Overlay name='Fields (Labeled)'>
              {fieldsLabeled}
            </Overlay>) : null }
            {fields_outlined !== undefined ? (<Overlay name='Fields (Outlined)'>
              {fields_outlined}
            </Overlay>) : null }
            {fieldsLabeled_outlined !== undefined ? (<Overlay name='Fields (Outlined & Labeled)'>
              {fieldsLabeled_outlined}
            </Overlay>) : null }
            {fields_crops !== undefined ? (<Overlay name='Fields Crop Status'>
              {fields_crops}
            </Overlay>) : null }
            {fields_planted_2021 !== undefined ? (<Overlay name='Fields Planted as of End-of-Year 2021'>
              {fields_planted_2021}
            </Overlay>) : null }
            {fields_west_2021 !== undefined ? (<Overlay name='Fields Planted as of End-of-Year 2021 (West Maui)'>
              {fields_west_2021}
            </Overlay>) : null }
            {fields_proposed_2022 !== undefined ? (<Overlay name='Fields Projected to be Planted in 2022'>
              {fields_proposed_2022}
            </Overlay>) : null }
            {fuel_tanks !== undefined ? (<Overlay name='Fuel Tanks'>
              {fuel_tanks}
            </Overlay>) : null }
            {endangered_species !== undefined ? (<Overlay name='Has Endangered Species'>
              {endangered_species}
            </Overlay>) : null }
            {military_areas !== undefined ? (<Overlay name='Military Areas'>
              {military_areas}
            </Overlay>) : null }
            {military_impacts !== undefined ? (<Overlay name='Military Impact Levels'>
              {military_impacts}
            </Overlay>) : null }
            {mills !== undefined ? (<Overlay name='Mills'>
              {mills}
            </Overlay>) : null }
            {oahu_farmable_acres !== undefined ? (<Overlay name='Oahu - Farmable Acres'>
              {oahu_farmable_acres}
            </Overlay>) : null }
            {oahu_wahiawa_parcels !== undefined ? (<Overlay name='Oahu - Wahaiwa Water Parcels'>
              {oahu_wahiawa_parcels}
            </Overlay>) : null }
            {oahu_dole_parcels !== undefined ? (<Overlay name='Oahu - Dole Owned Parcels'>
              {oahu_dole_parcels}
            </Overlay>) : null }
            {oahu_comps_parcels !== undefined ? (<Overlay name='Oahu - Comps Parcels'>
              {oahu_comps_parcels}
            </Overlay>) : null }
            {old_roads !== undefined ? (<Overlay name='Old Government Roads'>
              {old_roads}
            </Overlay>) : null }
            {other !== undefined ? (<Overlay name='Other Env. Issues'>
              {other}
            </Overlay>) : null }
            {parcels !== undefined ? (<Overlay name='Parcels (Outlined & Labeled)'>
              {parcels}
            </Overlay>) : null }
            {parcels_cpr !== undefined ? (<Overlay name='Parcels with CPR Carve Outs'>
              {parcels_cpr}
            </Overlay>) : null }
            {pineapple_fields !== undefined ? (<Overlay name='Pineapple Fields'>
              {pineapple_fields}
            </Overlay>) : null }
            {pineapple_pesticides !== undefined ? (<Overlay name='Pineapple Pesticide Mixing Stations'>
              {pineapple_pesticides}
            </Overlay>) : null }
            {schedule_a_parcels !== undefined ? (<Overlay name='Project Ratoon - Part II'>
              {schedule_a_parcels}
            </Overlay>) : null }
            {pumps !== undefined ? (<Overlay name='Pumps'>
              {pumps}
            </Overlay>) : null }
            {reservoirs !== undefined ? (<Overlay name='Reservoirs'>
              {reservoirs}
            </Overlay>) : null }
            {solar_projects !== undefined ? (<Overlay name='Solar Projects'>
              {solar_projects}
            </Overlay>) : null }
            {state_land !== undefined ? (<Overlay name='State Ownership'>
              {state_land}
            </Overlay>) : null }
            {topography !== undefined ? (<Overlay name='Topography'>
              {topography}
            </Overlay>) : null }
            {transformers !== undefined ? (<Overlay name='Transformers'>
              {transformers}
            </Overlay>) : null }
            {meters !== undefined ? (<Overlay name='Water Meters'>
              {meters}
            </Overlay>) : null }
            {fuel_wells !== undefined ? (<Overlay name='Wells'>
              {fuel_wells}
            </Overlay>) : null }
          </LayersControl>
          <ScaleControl position='bottomleft' />
          <Control position="bottomleft" style={{zIndex: 10}}>
            <div>
              { this.props.fillProperties && this.props.parameter ? legend : null }
            </div>
          </Control>
          <Control position="topright">
            <div>
              {propertySearch}
            </div>
          </Control>
          <Control position="topright">
            <div className="recenter-div">
              {fitBounds}
            </div>
          </Control>
          <Pane name="leaflet-properties-overlay-pane" style={{ zIndex: 300 }}>
            {this.props.showProperties && filteredProperties ? (filteredProperties) : null}
          </Pane>
        </Map>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.DataApp.get('filteredProperties'),
    allData: state.DataApp.get('data'),
    selectedProperty: state.DataApp.get('selectedProperty'),
    properties: state.DataApp.get('modifiedProperties'),
    filteredProperties: state.DataApp.get('filteredProperties'),

    showProperties: state.StatApp.get('showProperties'),
    showRadius: state.StatApp.get('showRadius'),
    fillProperties: state.StatApp.get('fillProperties'),
    //radius: state.StatApp.get('radius'),
    //showClusters: state.StatApp.get('showClusters'),
    //mapBreaks: state.StatApp.get('mapBreaks'),
    parameter: state.StatApp.get('parameter'),
    parameterType: state.StatApp.get('parameterType'),
    histogramSelection: state.StatApp.get('histogramSelection'),

    foundProperty: state.MapApp.get('foundProperty'),
    overlays: state.MapApp.get('overlays'),
    mapCenter: state.MapApp.get('mapCenter'),
    mapZoom: state.MapApp.get('mapZoom'),
    mapBounds: state.MapApp.get('mapBounds'),
    draggable: state.MapApp.get('draggable'),
    errorMessage: state.MapApp.get('errorMessage'),
    template: state.Template,
    isBusy: state.isBusy
  }
}

const DataMapView = connect(mapStateToProps)(DataMapViewComp)

export default DataMapView;



// WEBPACK FOOTER //
// ./src/components/MapView/DataMapView.js